import * as yup from 'yup';

export const AcceptInviteForm = yup.object().shape({
  email: yup.string().required({ tx: 'errors.required' }).email(),
  password: yup.string().required({ tx: 'errors.required' }).min(6),
});
